export const upcomingPreviews = [
  {
    id: "p-130",
    issue: "第 130 期",
    tag: "待证实",
    title: "顶流剧组内部合约风波，核心当事人或首次开腔",
    summary:
      "线人透露一段录音正在交叉核验，涉及档期与分成争议，预计本周内放出第一批时间线。",
    eta: "预计 48 小时内",
    heat: "热度 9.2",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20stylized%20silhouette%20of%20a%20vintage%20microphone%20in%20warm%20amber%20spotlight%20beams%2C%20grainy%20film%20texture%2C%20dark%20moody%20editorial%20poster%2C%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=heimao-prev-130&orientation=landscape",
  },
  {
    id: "p-129",
    issue: "第 129 期",
    tag: "追踪中",
    title: "人气组合巡演临时调整，官方口径与现场说法出现分歧",
    summary:
      "多地场次顺序被改动，线报称与设备与排期双线压力有关，我们正在补齐各地反馈。",
    eta: "预计 3 天",
    heat: "热度 8.4",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20geometric%20arrangement%20of%20film%20reels%20and%20light%20rays%20in%20warm%20brick%20red%20and%20gold%2C%20minimal%20editorial%20poster%20style%2C%20grainy%20paper%20texture%2C%20no%20text&width=800&height=600&seq=heimao-prev-129&orientation=landscape",
  },
  {
    id: "p-128",
    issue: "第 128 期",
    tag: "待证实",
    title: "匿名账号集中放料，同一批素材被指来源重合",
    summary:
      "三个账号在同一时段发布高度相似内容，我们把发布节点与素材指纹做了逐条比对。",
    eta: "预计 5 天",
    heat: "热度 7.6",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20collage%20of%20blurred%20stage%20lights%20and%20paper%20fragments%20in%20warm%20amber%20and%20deep%20red%2C%20grainy%20editorial%20texture%2C%20minimal%20composition%2C%20no%20text&width=800&height=600&seq=heimao-prev-128&orientation=landscape",
  },
];

export const unconfirmedItems = [
  {
    id: "u-01",
    category: "音乐",
    title: "M 姓歌手新专延期传闻",
    summary: "多方向信源提到母带阶段二次返工，官方至今未作回应。",
    confidence: 42,
    source: "线人 · 代号「青瓦」",
    updated: "2 小时前",
  },
  {
    id: "u-02",
    category: "综艺",
    title: "某综艺常驻阵容变动",
    summary: "录制通告单出现两处临时替换，节目组暂未置评。",
    confidence: 58,
    source: "线人 · 代号「北栈」",
    updated: "5 小时前",
  },
  {
    id: "u-03",
    category: "剧集",
    title: "都市剧番位争议外流截图",
    summary: "一张片头截图在小范围流传，剪辑顺序与官宣名单不一致。",
    confidence: 35,
    source: "线人 · 代号「夜航」",
    updated: "昨天",
  },
  {
    id: "u-04",
    category: "商业",
    title: "代言合约到期未续消息",
    summary: "品牌方物料下架时间与合约周期之间存在明显时间差。",
    confidence: 51,
    source: "线人 · 代号「白篱」",
    updated: "昨天",
  },
];

export const whisperItems = [
  {
    id: "w-01",
    code: "青瓦",
    text: "听说那场发布会的提问清单，在开场前被临时换过一轮。",
    time: "09·12 08:40",
    region: "华东",
  },
  {
    id: "w-02",
    code: "北栈",
    text: "有人在机场贵宾厅看到两组团队前后脚出现，行程高度重合。",
    time: "09·11 22:15",
    region: "华北",
  },
  {
    id: "w-03",
    code: "夜航",
    text: "片场通告单今天多了一页补拍安排，名单里少了两个人。",
    time: "09·11 18:02",
    region: "华南",
  },
  {
    id: "w-04",
    code: "白篱",
    text: "品牌的节日物料里，有一个人悄悄没有出现。",
    time: "09·10 13:27",
    region: "西南",
  },
];

export const topicItems = [
  { id: "t-01", name: "剧集风向", count: 128, trend: "+12%", up: true },
  { id: "t-02", name: "音乐现场", count: 96, trend: "+7%", up: true },
  { id: "t-03", name: "综艺录制", count: 74, trend: "-3%", up: false },
  { id: "t-04", name: "商业代言", count: 61, trend: "+5%", up: true },
  { id: "t-05", name: "短剧赛道", count: 40, trend: "+21%", up: true },
  { id: "t-06", name: "舞台幕后", count: 33, trend: "-1%", up: false },
];

export const trustStats = [
  { id: "s-01", label: "累计追踪", value: "1,284", unit: "条", note: "自 2023 年起持续更新" },
  { id: "s-02", label: "已证实", value: "312", unit: "条", note: "附完整时间线可回看" },
  { id: "s-03", label: "平均响应", value: "4.2", unit: "小时", note: "从收到线报到上版" },
  { id: "s-04", label: "在线线人", value: "96", unit: "位", note: "全部以代号出现" },
];

export const faqItems = [
  {
    id: "f-01",
    question: "预告里的消息，多久会给出结果？",
    answer:
      "我们以「期」为单位推进，多数预告会在 3–7 天内更新为「已证实」或「已排除」，进度会写进对应条目，方便你随时回看。",
  },
  {
    id: "f-02",
    question: "标注「待证实」是否等于已经确认？",
    answer:
      "不等于。待证实表示我们拿到了可交叉核对的第一手线索，但仍缺少至少一个独立信源；页面上的可信度百分比，就是当前的核验进度。",
  },
  {
    id: "f-03",
    question: "线人消息如何保护隐私？",
    answer:
      "所有线人只以代号呈现，我们仅公开与事件相关的可核验信息，联系方式与身份线索一律不进入页面。",
  },
  {
    id: "f-04",
    question: "如果消息最终被证伪，会怎么处理？",
    answer:
      "条目会保留并标注「已排除」与更正说明。我们不删除追踪记录，方便你回看整条时间线是怎么走过来的。",
  },
];

export const archiveItems = [
  { id: "a-01", issue: "127 期", date: "09·08", title: "巡演路透与官摄版本对不上" },
  { id: "a-02", issue: "126 期", date: "09·04", title: "两张通告单，两个开机时间" },
  { id: "a-03", issue: "125 期", date: "08·30", title: "剪辑顺序改动引发的连锁反应" },
  { id: "a-04", issue: "124 期", date: "08·26", title: "同一张图，三种来源" },
];